import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { OrdersProvider } from "../../contexts/orders/OrderContext";
import { RiderProvider } from "../../contexts/riderContext/RiderContext";
import OrderDetailFragment from './views/OrderDetailFragment';
import { SearchProvider } from './SearchStore';

const OrderFragment = Loadable(lazy(() => import('./views/OrderFragment')));





const orderRoutes = [
    { path: '/orders', element: <SearchProvider> <OrderFragment /></SearchProvider> },
    { path: '/orders/:sorting', element: 
    <SearchProvider>
        <OrdersProvider>
            <RiderProvider>
                <OrderFragment />
            </RiderProvider>
        </OrdersProvider>
    </SearchProvider>
         },
    { path: '/order_detail/:id', element: <OrdersProvider><OrderDetailFragment /></OrdersProvider> },
];

export default orderRoutes;




